import { Box, Button, Stack, Typography } from '@mui/material'
import { palette } from '../../myTheme'
import useMediaQuery from '@mui/material/useMediaQuery'
import KyrosImage1 from '../images/framedKyrosImage1.png'
import KyrosImage2 from '../images/framedKyrosImage2.png'
import KyrosImage3 from '../images/framedKyrosImage3.png'
import KyrosImage4 from '../images/framedKyrosImage4.png'
import KyrosImage5 from '../images/framedKyrosImage5.png'

const imageArray = [KyrosImage1, KyrosImage2, KyrosImage3, KyrosImage4, KyrosImage5]

export default function KyrosAppPage() {
  const isScreenSmall = useMediaQuery('(max-width: 1000px)')
  return (
    <Box margin={isScreenSmall ? 6 : 12}>
      <Stack spacing={8}>
        <Stack
          direction='row'
          style={{
            paddingBottom: 8,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography fontWeight={800} fontSize={isScreenSmall ? 18 : 70}>
            Kyros - Recovery Support
          </Typography>
          <Button
            style={{
              marginTop: isScreenSmall ? 0 : 13,
              maxHeight: isScreenSmall ? 40 : 80,
              fontSize: isScreenSmall ? 16 : 30,
            }}
            onClick={() => window.history.back()}
          >
            Back
          </Button>
        </Stack>

        <Typography
          style={{ textAlign: isScreenSmall ? 'center' : 'start' }}
          fontStyle={{ color: palette.white }}
          fontWeight={400}
          fontSize={isScreenSmall ? 14 : 20}
        >
          Kyros offers a transformative digital platform designed to guide
          individuals on their recovery wellness journey. Seamlessly connecting
          users with professional support and essential resources, Kyros
          revolutionizes the landscape of holistic recovery. Our human-centric
          approach ensures personalized care, fostering positive outcomes for
          millions impacted by substance use challenges. Experience the power of
          the Kyros platform, empowering you to navigate your path to recovery.
        </Typography>
        <Stack gap={2}>
          <Typography>Key Features</Typography>
          <Stack paddingLeft={4}>
            <Typography sx={{ display: 'list-item' }}>
              Direct access to professional support
            </Typography>
            <Typography sx={{ display: 'list-item' }}>
              Intuitive and user-friendly
            </Typography>
            <Typography sx={{ display: 'list-item' }}>
              Geolocation based check in system
            </Typography>
          </Stack>
          <Stack
            direction="row"
            spacing={4}
            style={{
              overflowX: isScreenSmall ? 'auto' : 'visible',
              flexWrap: isScreenSmall ? 'nowrap' : 'wrap',
              scrollSnapType: isScreenSmall ? 'x mandatory' : 'none',
              justifyContent: 'space-evenly'
            }}
          >
            {imageArray.map((imgSrc, index) => (
              <Box
                key={index}
                component="img"
                src={imgSrc}
                alt={`Image ${index}`}
                sx={{
                  height: 450,
                  borderRadius: 2,
                  flexShrink: 0,
                  scrollSnapAlign: isScreenSmall ? 'start' : 'none',
                }}
              />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}
